// Field type icons and configurations
import { Type, Mail, Phone, Hash, Calendar, Clock, ChevronDown, CheckSquare, Radio, Upload, AlignLeft, FileText, CheckCircle, User } from 'lucide-react';

export const FIELD_TYPES = [
  {
    type: 'name',
    label: 'Name',
    icon: User,
    category: 'basic',
    description: 'First, Middle, Last Name fields',
  },
  {
    type: 'text',
    label: 'Text Input',
    icon: Type,
    category: 'basic',
  },
  {
    type: 'email',
    label: 'Email',
    icon: Mail,
    category: 'basic',
  },
  {
    type: 'phone',
    label: 'Phone',
    icon: Phone,
    category: 'basic',
  },
  {
    type: 'number',
    label: 'Number',
    icon: Hash,
    category: 'basic',
  },
  {
    type: 'date',
    label: 'Date',
    icon: Calendar,
    category: 'basic',
  },
  {
    type: 'time',
    label: 'Time',
    icon: Clock,
    category: 'basic',
  },
  {
    type: 'textarea',
    label: 'Text Area',
    icon: AlignLeft,
    category: 'basic',
  },
  {
    type: 'dropdown',
    label: 'Dropdown',
    icon: ChevronDown,
    category: 'choice',
  },
  {
    type: 'radio',
    label: 'Radio Buttons',
    icon: Radio,
    category: 'choice',
  },
  {
    type: 'checkbox',
    label: 'Checkboxes',
    icon: CheckSquare,
    category: 'choice',
  },
  {
    type: 'file_upload',
    label: 'File Upload',
    icon: Upload,
    category: 'advanced',
  },
  {
    type: 'section_header',
    label: 'Section Header',
    icon: FileText,
    category: 'layout',
  },
  {
    type: 'terms_checkbox',
    label: 'Terms & Conditions',
    icon: CheckCircle,
    category: 'advanced',
  },
];

export const FIELD_CATEGORIES = [
  { id: 'basic', label: 'Basic Fields' },
  { id: 'choice', label: 'Choice Fields' },
  { id: 'advanced', label: 'Advanced' },
  { id: 'layout', label: 'Layout' },
];

export const createDefaultField = (type) => {
  const baseField = {
    id: `field_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    type,
    label: '',
    placeholder: '',
    help_text: '',
    required: false,
    order: 0,
    width: 'full',
  };

  // Add type-specific defaults
  const typeDefaults = {
    name: { 
      label: 'Full Name',
      name_config: {
        show_first_name: true,
        show_middle_name: false,
        show_last_name: true,
        first_name_label: 'First Name',
        middle_name_label: 'Middle Name',
        last_name_label: 'Last Name',
        first_name_placeholder: 'Enter first name',
        middle_name_placeholder: 'Enter middle name',
        last_name_placeholder: 'Enter last name',
      }
    },
    dropdown: { options: [{ label: 'Option 1', value: 'option1', price_modifier: 0 }] },
    radio: { options: [{ label: 'Option 1', value: 'option1', price_modifier: 0 }] },
    checkbox: { options: [{ label: 'Option 1', value: 'option1', price_modifier: 0 }] },
    section_header: { label: 'Section Title', help_text: 'Section description' },
    terms_checkbox: { label: 'I agree to the terms and conditions', required: true },
  };

  return {
    ...baseField,
    ...typeDefaults[type],
  };
};
